const uuid=/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
export function fluTaskOutcome(metadata:unknown):string|null{
 if(!metadata||typeof metadata!=='object'||Array.isArray(metadata))return null;
 const marker=(metadata as Record<string,any>)._flu_task_completion;
 if(!marker||marker.version!==1||!uuid.test(marker.actor_id||'')||!uuid.test(marker.proposal_id||'')||!uuid.test(marker.event_id||'')||typeof marker.outcome!=='string'||!marker.outcome.trim()||marker.outcome.length>2000)return null;
 return marker.outcome;
}
